module.exports = __webpack_public_path__ + "static/media/Tech_contentsPage_en.b32702be.png";